/**
 * Formats a full address from individual components.
 * Returns a string like "123 Main St, Chicago, IL 60601"
 * Gracefully handles missing parts.
 */
export function formatFullAddress(parts: {
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | number | null;
}): string {
  const { address, city, state, zipcode } = parts;

  const cityFormatted = city && city !== '-' ? city.charAt(0).toUpperCase() + city.slice(1).toLowerCase() : null;
  const stateFormatted = state && state !== '-' ? state.charAt(0).toUpperCase() + state.slice(1).toLowerCase() : null;
  const zip = zipcode ? String(zipcode) : null;

  // Build "City, ST 60601" portion
  const localeParts: string[] = [];
  if (cityFormatted) localeParts.push(cityFormatted);
  if (stateFormatted) {
    const stateWithZip = zip ? `${stateFormatted} ${zip}` : stateFormatted;
    localeParts.push(stateWithZip);
  } else if (zip) {
    localeParts.push(zip);
  }
  const locale = localeParts.join(', ');

  if (address && locale) return `${address}, ${locale}`;
  if (address) return address;
  if (locale) return locale;
  return 'No address available';
}
